module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-03.db214781.jpg";